
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/inbox",
      function () {
        return require("private-next-pages/account/inbox/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/inbox"])
      });
    }
  